/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useMemo } from 'react';
import './style.scss';
import PropTypes from 'prop-types';

import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import {
  Box,
  darken,
  lighten,
  useTheme,
  IconButton,
  Tooltip,
} from '@mui/material';

import { ReactComponent as Delete } from 'src/assets/icons/trash.svg';

export default function ContasTable({
  config,
  data,
  setSearch,
  setColuna,
  handleDelete,
}) {
  const menus = JSON.parse(localStorage.getItem('menus'));
  const headerColunas = menus.rateios;

  const columns = useMemo(
    () => [
      {
        id: 'delete',
        header: 'Deletar',
        enableEditing: false,
        grow: false,
        Cell: ({ row }) => (
          <Box className="deleteCell" sx={{ display: 'flex', gap: '1rem' }}>
            <Tooltip title="Deletar">
              <IconButton onClick={() => handleDelete(row)}>
                <Delete className="tableIcon line" />
              </IconButton>
            </Tooltip>
          </Box>
        ),
      },
      ...headerColunas.split(',').map((key) => ({
        header: (() => {
          switch (key.toLowerCase()) {
            case 'ctared':
              return 'Conta Contábil';
            case 'ctafin':
              return 'Conta Financeira';
            case 'numprj':
              return 'Projeto';
            case 'codfpj':
              return 'Fase';
            default:
              return key.toLowerCase();
          }
        })(),
        accessorKey: key.toLowerCase(),
        grow: false,
        enableEditing: false,
      })),
      {
        header: 'Valor',
        accessorKey: 'valor',
        enableEditing: true,
      },
      /*{
        header: 'Dif',
        accessorKey: 'dif',
      },*/
    ],
    [headerColunas]
  );

  const contasTable = useMaterialReactTable({
    columns,
    data,
    ...config,
  });

  return <MaterialReactTable table={contasTable} />;
}

ContasTable.propTypes = {
  config: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  setSearch: PropTypes.func,
  setColuna: PropTypes.func,
};
